import { FormattedMessage } from 'react-intl';
import { getEnv } from 'env/env';
import { Hyperlink } from './hyperlink';

export const PaymentFAQsLink = () => (
  <Hyperlink destination={getEnv('NEXT_PUBLIC_EDX_PAYMENT_FAQS_URL')}>
    <FormattedMessage
      id="checkout.error.payment.faqs.link"
      defaultMessage="Payments FAQ"
      description="The support link as in '{Payments FAQ}'"
    />
  </Hyperlink>
);
